export const normalizeZipCodeForApi = (value: string): string | undefined => {
  const trimmed = value.trim();
  return trimmed || undefined;
};
